import type { ApiContract, ApiContractRequest, ApiContractType, ApiDocument, ApiItemRef, ApiItemTypes, GenericHttpResult } from '@agunity/api-v4';

import { apiService } from '../../api/apiService';

type UploadFile = {
  file: File | null;
  itemType: number;
  itemId: number;
  name?: string;
  description?: string;
  url?: string;
};

export const getContractItems = (data: ApiItemRef[]) => {
  return async (): Promise<GenericHttpResult<ApiContract[]>> => {
    const response = await apiService.contractV10ListCreate(data);
    return response;
  };
};

export const getContractItem = (id: number) => {
  return async (): Promise<GenericHttpResult<ApiContract>> => {
    const response = await apiService.contractV10ItemDetail(id);
    return response;
  };
};

export const getContractTypes = () => {
  return async (): Promise<GenericHttpResult<ApiContractType[]>> => {
    const response = await apiService.contractV10TypeListList();
    return response;
  };
};

export const deleteContractItem = (id: number) => {
  return async (): Promise<GenericHttpResult<void>> => {
    const response = await apiService.contractV10ItemDelete(id);
    return response;
  };
};

export const uploadFile = ({ file, ...params }: UploadFile) => {
  return async (): Promise<GenericHttpResult<number> | void> => {
    if (!file) return;
    const data: any = new FormData();
    const fileBlob = new Blob([file.slice()], { type: file.type });
    data?.append('document', fileBlob, file.name ?? params?.name);
    data?.append('documentDetails', JSON.stringify(params));
    const response = await apiService.documentV12UploadCreate(data);
    return response;
  };
};

export const downloadDocument = (documentKey: string) => {
  return async (): Promise<GenericHttpResult<Blob>> => {
    const response = await apiService.documentV10DownloadDetail(documentKey);
    return response;
  };
};

export const getDocuments = (itemType: ApiItemTypes, itemId: number) => {
  return async (): Promise<GenericHttpResult<ApiDocument[]>> => {
    const response = await apiService.documentV10ListDetail(itemType, itemId);
    return response;
  };
};

export const deleteDocument = (documentKey: string) => {
  return async (): Promise<GenericHttpResult<void>> => {
    const response = await apiService.documentV10DeleteDelete(documentKey);
    return response;
  };
};

export const postContractItems = (itemType: ApiItemTypes, id: number, data: ApiContractRequest) => {
  return async (): Promise<GenericHttpResult<number>> => {
    const response = await apiService.contractV10ItemCreate(itemType, id, data);
    return response;
  };
};
export const patchContractItems = (id: number, data: ApiContractRequest) => {
  return async (): Promise<GenericHttpResult<void>> => {
    const response = await apiService.contractV10ItemPartialUpdate(id, data);
    return response;
  };
};